import type { Location } from 'react-router-dom';

import { removeParams, addParams } from './query';
import { getReferrer } from './referrer';

export const toWithSearch = (path, location, options = {}) => {
  const hydratedOptions = { match: { params: {} }, keepForce: false, removeParams: [], ...options };
  const { search } = location;
  if (hydratedOptions.match && hydratedOptions.match.params) {
    Object.entries(hydratedOptions.match.params).forEach(([key, entry]) => {
      path = path.replace(`:${key}`, entry);
    });
  }
  if (!hydratedOptions.keepForce) {
    hydratedOptions.removeParams.push('force');
  }
  const filteredSearch = removeParams(search, hydratedOptions.removeParams);
  return path + filteredSearch;
};

type RewriteUrlProps = {
  from: string;
  to: string;
  location: Location;
};

export const rewriteUrl = ({ from, to, location }: RewriteUrlProps) => {
  let url = location.pathname.replace(from, to);
  if (location.search) {
    url += `?${location.search.replace(/^\?/, '')}`;
  }
  if (location.hash) {
    url += `#${location.hash.replace(/^#/, '')}`;
  }
  return url;
};

const vehicleParams = [
  'year',
  'make',
  'model',
  'trim',
  'vin',
  'licensePlate',
  'plateState',
  'referrer'
];

export const buildNavigationUrl = (
  baseUrl: string,
  paramsToAdd: { [key: string]: string } = {},
  paramsToRemove: string[] = [],
  initialSearch?: string
): string => {
  if (typeof window === 'undefined') {
    return `${baseUrl}`;
  }

  const search = initialSearch || (window?.location?.search ?? '');
  const allParamsToRemove = [...paramsToRemove, ...vehicleParams];
  const allParamsToAdd = { ...paramsToAdd, referrer: getReferrer()?.match?.slice(1) };
  const filteredSearch = removeParams(search, allParamsToRemove);
  const hydratedSearch = addParams(filteredSearch, allParamsToAdd);
  return `${baseUrl}${hydratedSearch}`;
};
